/*
 * Página de Produto — Ariel Malhas
 * Galeria, seleção de variante, quantidade, "Ver mais" e cálculo de frete
 * (Melhor Envio via proxy — o token fica no proxy, nunca no tema).
 */
(function () {
  'use strict';

  var VARIANTS = [];

  function parseVariants() {
    var el = document.querySelector('[data-apdp-variants]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return [];
    }
  }

  function getCurrentVariant() {
    var idInput = document.querySelector('[data-variant-id-input]');
    var id = idInput ? parseInt(idInput.value, 10) : null;
    var found = VARIANTS.filter(function (v) {
      return v.id === id;
    })[0];
    return found || VARIANTS[0] || null;
  }

  function getQuantity() {
    var input = document.querySelector('.apdp__qty [data-qty-input]');
    var q = input ? parseInt(input.value, 10) : 1;
    return isNaN(q) || q < 1 ? 1 : q;
  }

  function money(value) {
    return 'R$ ' + Number(value).toFixed(2).replace('.', ',');
  }

  /* ------- Disponibilidade: bloco de compra × aviso de reposição -------
     O formulário próprio de "Avise-me" foi removido — quem cuida da captura
     agora é o Back in Stock do Klaviyo. Aqui restou o essencial:
       1. esconder o bloco de compra quando a variante está sem estoque;
       2. revelar a área do Klaviyo, já com o ID da variante escolhida. */
  function toggleAvailability(variant) {
    var buy = document.querySelector('.apdp__buy');
    var bis = document.querySelector('[data-bis]');
    var outOfStock = !variant || !variant.available;

    if (buy) buy.hidden = outOfStock;
    if (bis) {
      bis.hidden = !outOfStock;
      if (variant && variant.id) bis.setAttribute('data-bis-variant', variant.id);
    }
  }

  function init() {
    VARIANTS = parseVariants();
    initThumbsScroll();
    initGallery();
    initVariants();
    initSwatches();
    initSeeMore();
    initFrete();
  }

  /* ---------------- Grade de cores (tag "swatches") ----------------
     Os swatches não têm lógica própria de variante: eles escrevem no
     <select> oculto e disparam 'change', reaproveitando initVariants()
     (preço, disponibilidade, botão comprar, "Avise-me"). */
  function initSwatches() {
    var swatches = Array.prototype.slice.call(document.querySelectorAll('[data-swatch]'));
    if (swatches.length === 0) return;

    var select = document.querySelector('[data-option-index="0"]');
    var current = document.querySelector('[data-swatch-current]');
    if (!select) return;

    function select_(btn) {
      var value = btn.getAttribute('data-value');

      swatches.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });

      if (current) current.textContent = value;

      // Dispara a lógica de variante já existente.
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));

      // Imagem em destaque passa a ser a da cor escolhida.
      var img = btn.getAttribute('data-image');
      if (img && window.__apdpGallery) window.__apdpGallery.setBySrc(img);
    }

    swatches.forEach(function (btn) {
      btn.addEventListener('click', function () {
        select_(btn);
      });
    });
  }

  /* ---------------- Carrossel vertical das miniaturas ---------------- */
  function initThumbsScroll() {
    var viewport = document.querySelector('[data-thumbs-viewport]');
    var up = document.querySelector('[data-thumbs-up]');
    var down = document.querySelector('[data-thumbs-down]');
    // Setas só existem quando há mais de 6 imagens; sem elas, nada a fazer.
    if (!viewport || !up || !down) return;

    // Rola ~3 miniaturas por clique (thumb 70px + gap 10px).
    var step = (70 + 10) * 3;

    function update() {
      var atTop = viewport.scrollTop <= 1;
      var atBottom = viewport.scrollTop + viewport.clientHeight >= viewport.scrollHeight - 1;
      up.hidden = atTop;
      down.hidden = atBottom;
    }

    function ensureVisible(el) {
      if (!el) return;
      var vr = viewport.getBoundingClientRect();
      var er = el.getBoundingClientRect();
      if (er.top < vr.top) {
        viewport.scrollBy({ top: er.top - vr.top - 6, behavior: 'smooth' });
      } else if (er.bottom > vr.bottom) {
        viewport.scrollBy({ top: er.bottom - vr.bottom + 6, behavior: 'smooth' });
      }
    }

    up.addEventListener('click', function () {
      viewport.scrollBy({ top: -step, behavior: 'smooth' });
    });
    down.addEventListener('click', function () {
      viewport.scrollBy({ top: step, behavior: 'smooth' });
    });
    viewport.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    update();

    // Exposto para a galeria manter a miniatura ativa visível ao navegar.
    window.__apdpThumbsScroll = { update: update, ensureVisible: ensureVisible };
  }

  /* ---------------- Galeria ---------------- */
  function initGallery() {
    var main = document.querySelector('[data-main-image]');
    if (!main) return;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-thumb]'));
    var dots = Array.prototype.slice.call(document.querySelectorAll('[data-dot]'));
    // Não abortamos quando não há miniaturas: em produtos "swatches" a galeria
    // pode ter uma imagem só, e a API abaixo ainda precisa existir para que o
    // clique numa cor troque a imagem em destaque.

    var srcs = thumbs.map(function (t) {
      return t.getAttribute('data-full');
    });
    var index = 0;

    function setIndex(i) {
      if (srcs.length === 0) return;
      if (i < 0) i = srcs.length - 1;
      if (i >= srcs.length) i = 0;
      index = i;
      main.setAttribute('src', srcs[i]);
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === i);
      });
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === i);
      });
      // Mantém a miniatura ativa visível dentro do carrossel vertical.
      if (window.__apdpThumbsScroll) window.__apdpThumbsScroll.ensureVisible(thumbs[i]);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        setIndex(parseInt(t.getAttribute('data-index'), 10) || 0);
      });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        setIndex(parseInt(d.getAttribute('data-index'), 10) || 0);
      });
    });

    var prev = document.querySelector('[data-gallery-prev]');
    var next = document.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { setIndex(index - 1); });
    if (next) next.addEventListener('click', function () { setIndex(index + 1); });

    /* Swipe horizontal na imagem principal — no mobile as miniaturas ficam
       ocultas, então o arraste passa a ser a navegação primária.
       Só ativa em telas pequenas para não interferir no desktop. */
    var mobile = window.matchMedia('(max-width: 749px)');
    var stage = main.closest('.apdp__stage') || main.parentElement;
    var swipeStartX = 0;
    var swiping = false;

    if (stage) {
      stage.addEventListener('pointerdown', function (e) {
        if (!mobile.matches) return;
        swiping = true;
        swipeStartX = e.clientX;
      });

      stage.addEventListener('pointerup', function (e) {
        if (!swiping) return;
        swiping = false;
        var delta = e.clientX - swipeStartX;
        if (Math.abs(delta) > 40) setIndex(delta < 0 ? index + 1 : index - 1);
      });

      stage.addEventListener('pointercancel', function () {
        swiping = false;
      });
    }

    window.__apdpGallery = {
      setBySrc: function (src) {
        if (!src) return;
        var pos = srcs.indexOf(src);
        if (pos > -1) setIndex(pos);
        else main.setAttribute('src', src);
      },
    };
  }

  /* ---------------- Variantes ---------------- */
  function initVariants() {
    var selects = Array.prototype.slice.call(document.querySelectorAll('[data-option-index]'));
    if (selects.length === 0 || VARIANTS.length === 0) return;

    var idInput = document.querySelector('[data-variant-id-input]');
    var priceEl = document.querySelector('[data-price]');
    var compareEl = document.querySelector('[data-compare]');
    var badgeEl = document.querySelector('[data-badge]');
    var buyBtn = document.querySelector('.apdp__buy-btn');

    function currentValues() {
      var values = [];
      selects.forEach(function (sel) {
        values[parseInt(sel.getAttribute('data-option-index'), 10)] = sel.value;
      });
      return values;
    }

    function findVariant(values) {
      return VARIANTS.filter(function (v) {
        return (
          v.options.length === values.length &&
          v.options.every(function (o, i) {
            return o === values[i];
          })
        );
      })[0];
    }

    function apply() {
      var v = findVariant(currentValues());
      if (!v) return;

      if (idInput) {
        idInput.value = v.id;
        if (v.available) idInput.removeAttribute('disabled');
        else idInput.setAttribute('disabled', '');
      }
      if (priceEl && v.priceText) priceEl.textContent = v.priceText;
      if (compareEl) {
        if (v.compareText) {
          compareEl.textContent = v.compareText;
          compareEl.removeAttribute('hidden');
        } else {
          compareEl.setAttribute('hidden', '');
        }
      }
      if (badgeEl) {
        if (v.discount > 0) {
          badgeEl.textContent = v.discount + '% off';
          badgeEl.style.display = '';
        } else {
          badgeEl.style.display = 'none';
        }
      }
      if (buyBtn) buyBtn.disabled = !v.available;
      toggleAvailability(v);
      if (v.image && window.__apdpGallery) window.__apdpGallery.setBySrc(v.image);
    }

    selects.forEach(function (sel) {
      sel.addEventListener('change', apply);
    });
  }

  /* ---------------- Quantidade ---------------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var up = e.target.closest('.apdp__qty [data-qty-up]');
    var down = e.target.closest('.apdp__qty [data-qty-down]');
    if (!up && !down) return;
    e.preventDefault();
    var wrap = (up || down).closest('[data-qty]');
    var input = wrap && wrap.querySelector('[data-qty-input]');
    if (!input) return;
    var val = parseInt(input.value, 10);
    if (isNaN(val)) val = 1;
    val = Math.max(1, val + (up ? 1 : -1));
    input.value = val;
  });

  document.addEventListener('input', function (e) {
    if (!e.target.closest) return;
    var input = e.target.closest('.apdp__qty [data-qty-input]');
    if (!input) return;
    input.value = input.value.replace(/[^0-9]/g, '');
  });

  /* ---------------- Ver mais (âncora) ---------------- */
  function initSeeMore() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (!e.target.closest('[data-scroll-desc]')) return;
      var target = document.getElementById('ariel-product-description');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---------------- Frete (Melhor Envio via proxy) ---------------- */
  function initFrete() {
    var box = document.querySelector('[data-shipping-calc]');
    if (!box) return;
    var cepInput = box.querySelector('[data-cep-input]');
    var btn = box.querySelector('[data-calc-frete]');
    var result = box.querySelector('[data-frete-result]');
    if (!btn || !cepInput || !result) return;

    // Máscara de CEP (00000-000)
    cepInput.addEventListener('input', function () {
      var d = cepInput.value.replace(/\D/g, '').slice(0, 8);
      cepInput.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
    });

    function show(html, cls) {
      result.hidden = false;
      result.className = 'apdp__shipping-result' + (cls ? ' ' + cls : '');
      result.innerHTML = html;
    }

    function calc() {
      var url = box.getAttribute('data-frete-url');
      var cep = cepInput.value.replace(/\D/g, '');

      if (cep.length !== 8) {
        show('Digite um CEP válido (8 dígitos).', 'is-error');
        return;
      }
      if (!url) {
        show('Cálculo de frete ainda não configurado.', 'is-error');
        return;
      }

      var variant = getCurrentVariant();
      var qty = getQuantity();
      var defWeight = parseInt(box.getAttribute('data-frete-default-weight'), 10) || 300;
      var weightG = variant && variant.weight ? variant.weight : defWeight;
      var priceReais = variant && variant.price ? variant.price / 100 : 0;

      var payload = {
        to: cep,
        products: [
          {
            id: variant ? String(variant.id) : '1',
            width: parseFloat(box.getAttribute('data-frete-width')) || 11,
            height: parseFloat(box.getAttribute('data-frete-height')) || 4,
            length: parseFloat(box.getAttribute('data-frete-length')) || 16,
            weight: Math.max(0.01, weightG / 1000),
            insurance_value: priceReais,
            quantity: qty,
          },
        ],
      };

      btn.disabled = true;
      var oldLabel = btn.textContent;
      btn.textContent = 'CALCULANDO...';
      show('Consultando fretes...', 'is-loading');

      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (r) {
          if (!r.ok) throw new Error('http ' + r.status);
          return r.json();
        })
        .then(function (data) {
          renderOptions(Array.isArray(data) ? data : data.services || []);
        })
        .catch(function () {
          show('Não foi possível calcular o frete agora. Tente novamente.', 'is-error');
        })
        .finally(function () {
          btn.disabled = false;
          btn.textContent = oldLabel;
        });
    }

    var FREE_SHIPPING_MIN = 200; // frete grátis para pedidos a partir deste valor (R$)
    var PREFERRED_CARRIERS = ['jadlog', 'correios', 'jet']; // JT = J&T (vem como "JeT")

    // Seleciona até 3 opções, preferindo Jadlog, Correios e JT (a mais barata
    // de cada). Completa com as mais baratas restantes e reordena por preço.
    function pickTop3(sorted) {
      var chosen = [];
      var used = {};
      PREFERRED_CARRIERS.forEach(function (key) {
        for (var i = 0; i < sorted.length; i++) {
          if (used[i]) continue;
          var cname = ((sorted[i].company && sorted[i].company.name) || '').toLowerCase();
          if (cname.indexOf(key) !== -1) {
            chosen.push(sorted[i]);
            used[i] = true;
            break;
          }
        }
      });
      for (var j = 0; j < sorted.length && chosen.length < 3; j++) {
        if (!used[j]) {
          chosen.push(sorted[j]);
          used[j] = true;
        }
      }
      chosen.sort(function (a, b) {
        return parseFloat(a.price) - parseFloat(b.price);
      });
      return chosen.slice(0, 3);
    }

    function freeShipNotice() {
      return (
        '<div class="apdp__frete-freeship">' +
        '<strong>FRETE GRÁTIS</strong> para compras acima de <strong>R$200,00</strong>.<br>' +
        'Inclua mais itens em seu carrinho.' +
        '</div>'
      );
    }

    function renderOptions(services) {
      var valid = services.filter(function (s) {
        return s && s.price && !s.error;
      });
      if (valid.length === 0) {
        show('Nenhuma opção de frete encontrada para este CEP.', 'is-error');
        return;
      }

      // 1. Ordena do mais barato para o mais caro
      valid.sort(function (a, b) {
        return parseFloat(a.price) - parseFloat(b.price);
      });

      // 2. Mostra só as 3 melhores (preferindo Jadlog, Correios e JT)
      var top = pickTop3(valid);

      // 3. "Grátis" apenas quando o subtotal do pedido atinge o mínimo
      var variant = getCurrentVariant();
      var qty = getQuantity();
      var subtotal = variant && variant.price ? (variant.price / 100) * qty : 0;
      var isFree = subtotal >= FREE_SHIPPING_MIN;

      var rows = top
        .map(function (s, i) {
          var logo =
            s.company && s.company.picture
              ? '<img class="apdp__frete-logo" src="' + s.company.picture + '" alt="" loading="lazy">'
              : '';
          var name = (s.company && s.company.name ? s.company.name + ' ' : '') + (s.name || '');

          var days = '';
          if (s.delivery_range && s.delivery_range.min) {
            days =
              s.delivery_range.min === s.delivery_range.max
                ? s.delivery_range.max + ' dias úteis'
                : s.delivery_range.min + ' a ' + s.delivery_range.max + ' dias úteis';
          } else if (s.delivery_time) {
            days = s.delivery_time + ' dias úteis';
          }

          var price = isFree
            ? '<span class="apdp__frete-price apdp__frete-price--free">Grátis</span>'
            : '<span class="apdp__frete-price">' + money(s.price) + '</span>';

          // 4. Destaque do mais barato (apenas quando não é grátis)
          var isBest = i === 0 && !isFree;
          var bestTag = isBest ? '<span class="apdp__frete-best">Mais barato</span>' : '';

          return (
            '<li class="apdp__frete-option' + (isBest ? ' apdp__frete-option--best' : '') + '">' +
            logo +
            '<span class="apdp__frete-name">' + name + bestTag + '</span>' +
            '<span class="apdp__frete-days">' + days + '</span>' +
            price +
            '</li>'
          );
        })
        .join('');
      var notice = isFree ? '' : freeShipNotice();
      show('<ul class="apdp__frete-list">' + rows + '</ul>' + notice, '');
    }

    btn.addEventListener('click', calc);
    cepInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); calc(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
